'use strict';

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/locale-provider/style/index.js
// module id = 435
// module chunks = 0